/**
 * Created by esenckewitch on 04.03.2026.
 */

const OKBridgeSocial = function () {
    VKSocial.call(this);
};

OKBridgeSocial.prototype = Object.create(VKSocial.prototype);
OKBridgeSocial.prototype.constructor = OKBridgeSocial;

OKBridgeSocial.prototype._getUserID = function () {
    return connector.utils.getRequestParameters().vk_ok_user_id;
};

OKBridgeSocial.prototype._aboutMe = function (callback) {
    vkBridge.send("OKWebAppCallAPIMethod", {
        method: "users.getCurrentUser",
        params: {
            fields: "FIRST_NAME,LAST_NAME,PIC128X128,UID"
        }
    }).then((data) => {
        callback(connector.CODE_SUCCEED, OKBridgeSocial.formatUserData(data.response));
    }).catch(() => {
        callback(connector.CODE_FAILED);
    });
};

OKBridgeSocial.prototype.getAccessTokenPrefix = function () {
    return "OKBRIDGE_";
};

OKBridgeSocial.formatUserData = function (user) {
    let avatar = user.pic_2 || "";
    if (avatar.indexOf("stub_128x128.gif") !== -1 || avatar.indexOf("stub/user") !== -1) {
        avatar = "";
    }

    return {
        id: `${user.uid}`,
        name: `${user.first_name} ${user.last_name}`,
        firstName: user.first_name,
        lastName: user.last_name,
        avatar: avatar || undefined
    };
};
